<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body" class="is-2column" 
    :class="{'is-hidden-header' : targetScrollFlg}"
  >
  <BackgroundImage />
  <DocumentLink />

    <!-- menu:start -->
    <PCMenu
      class="visible"
      v-if="visibleMenu"
      @searchByKeyword="group1.search"
      @closeMenu="visibleMenu = false"
    />
    <!-- menu:end -->

    <div id="wrapper">
      <!-- header:start -->
      <PCSearchUI 
        :screenType="'download'"
        :isAlertShown="false"
        :isSearchExecutedAtSameScreen="true"
        @search="group1.searchWithOptions"
      />
      <!-- header:end -->

      <!-- menu-bar:start -->
      <!-- open -->
      <div class="menu-bar" role="button" 
        :class="{'is-open' : !targetScrollFlg}"
        @click="visibleMenu = !visibleMenu"
      >
        <IconMenu class="icn" 
          v-if="!targetScrollFlg"
        />
        <FontawesomeIcon :icon="['far','chevron-up']" size="lg" class="icn"
          v-if="targetScrollFlg"
        />
      </div>
      <!-- close -->
      <!-- menu-bar:end -->

      <!-- content:start -->
      <div id="content">
        <div class="" id="navi">
          <div class="navigation-title">絞り込み</div>
          <div class="navigation-list pb72"
            style="height:calc(100vh - 84px);"
            >

            <FontawesomeIcon v-if="!group1.isListPackagesAndProductsLoaded" :icon="['fal','spinner-third']" size="2x" class="icn fa-spin" style="height:100%;" />
            <template v-else>

              <p v-if="!group1.packagesAndProductsDataExists" class="txt pt20 pl20" style="color:white;">検索結果がありません。</p>
              <template v-else>
                <nav v-if="group1.packagesAndProductsAreaTreeData.packages.length > 0" class="list01 bg-02">
                  <PCPackageAndProductsTreeItem
                    :model="group1.packagesAndProductsAreaTreeData"
                    :isSearchCountShown="group1.isSearchCountShown"
                    @emitItemClicked="group1.onPackageAndProductsTreeItemClicked"
                  />                
                </nav>

                <nav v-if="group1.packagesAndProductsAreaBooks.length > 0" class="list01 bg-02">
                  <ul>
                    <li v-for="item in group1.packagesAndProductsAreaBooks" :key="item.id" class="list01-item is-parent is-open">
                      <div class="label">
                        <div class="formparts checkbox">
                          <input type="checkbox" 
                            v-model="group1.single_books"
                            :value="item.product_id + ',' + item.book_id"
                            @change="group1.onSingleBookClicked"
                            :id="'package_product_books_' + item.id">
                          <label :for="'package_product_books_' + item.id">{{ item.name }} <template v-if="group1.isSearchCountShown">({{ item.search_count_disp }})</template><FontawesomeIcon icon="check" class="icn" /></label>
                        </div>
                      </div>
                    </li>
                  </ul>
                </nav>

              </template>
            </template>

          </div>
        </div>
        <main class="" id="main">
          <div class="box02 white">

            <!-- キーワード検索中でない場合 -->
            <div v-if="!group1.isKeywordSearch" class="box02-hdg">
              <h1 class="box02-hdg-title hdg03">書式ダウンロード</h1>
              <span v-if="group1.isMatchedTotalLoaded" class="box02-hdg-title-sup">{{ group1.matchedTotal4Disp }}件</span>
              <span v-if="group1.isSearchConditionClearable" @click="group1.clearSearch" class="box02-hdg-title-sup-link" role="button">検索をクリア</span>
            </div>
            <!-- キーワード検索中の場合 -->
            <div v-else class="box02-hdg">
              <h1 class="box02-hdg-title hdg03">検索結果</h1>
              <span v-if="group1.isMatchedTotalLoaded" class="box02-hdg-title-sup">{{ group1.matchedTotal4Disp }}件</span>
              <span v-if="group1.isSearchConditionClearable" @click="group1.clearSearch" class="box02-hdg-title-sup-link" role="button">検索をクリア</span>
            </div>

            <div class="box02-body">
              <div class="box02-body-title pb72"
                style="height:calc(100vh - 120px);"
                >

                <FontawesomeIcon v-if="!group1.isListBooksLoaded" :icon="['fal','spinner-third']" size="2x" class="icn fa-spin" style="height:100%;" />
                <template v-else>

                  <p v-if="!group1.booksDataExists" class="txt pt20 pl20" style="color:#555555;">検索結果がありません。</p>
                  <ul v-else>
                    <li v-for="item in group1.booksAreaProducts" :key="'book_area_products_' + item.id">
                      <p class="box02-body-title-hdg">{{ item.name }}</p>
                      <ul class="box02-body-title-list">
                        <li v-for="item2 in item.books" :key="'book_area_products_books_' + item2.id"
                        class="box02-body-title-list-item">
                          <span role="button" class="box02-body-title-list-item-text"
                            @click="group1.selectBook('package_book', item2.id, item2.product_id, item2.book_id, item2.name)"
                            :class="{'is-selected': item2.isSelected}">{{ item2.name }} <span v-if="group1.isKeywordSearch">({{ item2.search_count }})</span></span>
                        </li>
                      </ul>
                    </li>
                    <li v-if="group1.booksAreaBooks.length > 0">
                      <ul class="box02-body-title-list mt36">
                        <li v-for="item in group1.booksAreaBooks" :key="'book_area_books_' + item.id"
                        class="box02-body-title-list-item">
                          <span role="button" class="box02-body-title-list-item-text"
                            @click="group1.selectBook('single_book', item.id, item.product_id, item.book_id, item.name)"
                          :class="{'is-selected': item.isSelected}">{{ item.name }} <span v-if="group1.isKeywordSearch">({{ item.search_count_disp }})</span></span>
                        </li>
                      </ul>
                    </li>
                  </ul>

                </template>

              </div>
              <div class="box02-body-detail" id="scroll-target"
                @scroll="handleScroll"
                style="height:calc(100vh - 120px);"
              >

                <FontawesomeIcon v-if="!group1.isListBooksAndFormDownloadsLoaded"
                  :icon="['fal','spinner-third']" size="2x" class="icn fa-spin" style="height:100%;" />
                <template v-else>

                  <p v-if="!group1.documentDownloadsExists || !group1.booksDataExists" class="txt pt32 pb32 pl40 pr40">キーワードに合致する検索結果がありませんでした。<br>検索キーワードを変更して再度検索してください。</p>
                  <template v-else>
                    <!-- <div class="box02-body-detail-menu">
                      <span role="button"
                        @click="group1.openAllTableOfContents"
                        >すべて開く
                      </span>
                      <span role="button"
                        @click="group1.closeAllTableOfContents"
                        >すべて閉じる
                      </span>
                    </div> -->
                    <p class="box02-body-detail-title">{{ group1.currentBookName }}</p>

                    <div class="list02">
                      <PCDocumentDownloadsTreeItem 
                        :model="group1.documentDownloadsAreaTreeData"
                        :matchedStartNo="group1.matchedStartNo"
                        :matchedEndNo="group1.matchedEndNo"
                        :matchedTotal="group1.matchedTotal"
                      />
                    </div>
                  </template>
                </template>

              </div>
            </div>
          </div>
        </main>
      </div>
      <!-- content:end -->

      <span id="btnTop" @click="scrollAreaTop('#scroll-target')">TOP</span>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'

import PCSearchUI from '@/components/pc/partial/PCSearchUI'
import PCMenu from '@/components/pc/popup/PCMenu.vue'
import PCBasicToast from '@/components/pc/popup/PCBasicToast.vue'

import * as logicDocumentDownloadsList from '@/logic/qa/DocumentDownloadsList'
import PCPackageAndProductsTreeItem from '@/components/pc/partial/qa/PCPackageAndProductsTreeItem'
import PCDocumentDownloadsTreeItem from '@/components/pc/partial/qa/PCDocumentDownloadsTreeItem'
import { isFromAdminSystem } from '@/util/common'

export default defineComponent({
  components: {
    PCSearchUI,
    PCMenu,
    PCBasicToast,
    PCPackageAndProductsTreeItem,
    PCDocumentDownloadsTreeItem
  },  
  setup (props, context) {

    const { group1, searchSelect } = logicDocumentDownloadsList.getGroup(props, context)

    const state = reactive({
      visibleToast: false,
      visibleBooksMenu: true,
      isOpenMenuArrow: false
    })

    return {
      group1,
      state,
      searchSelect,
      isFromAdminSystem
    }
  }
})
</script>

<style lang="scss" scoped>
  ::v-deep .box02-body {
    display: flex;
    &-title,
    &-detail {
      overflow-y: auto;
      transition: all .2s ease;
    }
    &-title {
      width: 30%;
      &-hdg {
        color: $color-sup;
        font-size: 1.6rem;
        margin: 40px 40px 0;
        line-height: 1.2em;
      }
      &-list {
        margin-top: 12px;
        list-style: none;
        &-item {
          &-text {
            display: block;
            padding: 6px 20px 6px 40px;
            color: $color-link;
            font-weight: bold;
            font-size: 1.6rem;
            line-height: 1.2em;
            @include hoverOpacity();
            &.is-selected {
              background-color: $color-selected;
            }
          }
        }
      }
    }
    &-detail {
      position: relative;
      width: 70%;
      border-left: 1px solid $color-line;
      padding-left: 40px;
      padding-top: 40px;
      &-title {
        margin-top: 10px;
        color: $color-link;
        font-size: 1.6rem;
        font-weight: bold;
        line-height: 1.2em;
      }
      &-menu {
        text-align: right;
        color: $color-sup;
        font-size: 1.2rem;
        span {
          display: inline-block;
          padding: 0 20px;
          text-decoration: underline;
          @include hoverOpacity;
          & + span {
            border-left: 1px solid $color-line;
          }
        }
      }
      .list02 {
        margin: 16px 0 0;
        padding-bottom: 60px;
        padding-left: 10px;
        line-height: 1.2em;
        &-item {
          &:not(.is-parent) .wrap {
            .label {
            }
            .main {
              color: $color-content;
            } 
          }
          .wrap {
            padding-top: 8px;
            padding-bottom: 8px;
          }
          .label {
            padding-left: 0;
            &:before {
              display: none;
            }
          }
        }
      }
    }
  }
</style>
